import { render, staticRenderFns } from "./input-required-indicator.vue?vue&type=template&id=5cebdf99"
import script from "./input-required-indicator.vue?vue&type=script&lang=js"
export * from "./input-required-indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports